/* eslint-disable no-console */
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

export const getProductDetails = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.FETCH_PRODUCT_LIST.GET}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveMarkCompleted = async (params, payload) => {
  const urlParams = new URLSearchParams({ isComplete: payload });
  try {
    return await apiClient.post(`${apiEndpoint}${API.FETCH_PRODUCT_LIST.GET}/${params.type}/${params.devOrderId}/care-label?${urlParams}`, {});
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCareLabelProduct = async (data) => {
  const typeData = data.type;
  try {
    return await apiClient.get(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.GET_CARE_LABEL}/${data.devOrderId}/${typeData}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCareInstructionProduct = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.GET_PRODUCT_CARE_INSTRUCTION}/${data.devOrderId}`, { params: data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCareLabelLibraryList = async (data) => {
  const urlParams = new URLSearchParams({ type: data.type, searchText: data.searchText });
  try {
    return await apiClient.get(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.GET_CARE_LABEL}?${urlParams}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCareLabeGroupList = async (data) => {
  const urlParams = new URLSearchParams({ type: data.type, searchText: data.searchText, libraryName: data.libraryName });
  try {
    return await apiClient.get(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.GET_CARE_LABEL_GROUP}?${urlParams}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCareLabeProductList = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.GET_CARE_LABEL_PRODUCT}/${data}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getLabelProductAsyncData = async (data) => {
  const urlParams = new URLSearchParams({
    type: data.type,
    searchText: data.searchText,
    currentDevOrderId: data.currentDevOrderId,
    devOrderId: data.devOrderId,
  });
  try {
    return await apiClient.get(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.GET_CARE_LABEL_PRODUCT_LIST}?${urlParams}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addCareLabelLibrary = async (params) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.GET_CARE_LABEL}/${params.devOrderId}`, { ...params });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addCareLabelGroup = async (params) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.GET_CARE_LABEL_GROUP}`, { ...params });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addCareLabelProduct = async (params) => {
  try {
    const data = {
      devOrderId: params.devOrderId,
      selectedDevOrderId: params.selectedDevOrderId,
      libId: params.libId,
    };
    return await apiClient.post(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.GET_CARE_LABEL_PRODUCT_DATA}/${params.devOrderId}/${params.careType}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteCareLabel = async (params) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.GET_CARE_LABEL}/${params.devOrderId}/${params.id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteMultipleCareLabel = async (devOrderId, payload) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.GET_CARE_LABEL}/${devOrderId}/1`, {
      data: payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addCareLabel = async (devOrderId, payload) => {
  try {
    return await apiClient.post(
      `${apiEndpoint}${API.CARE_LABEL_PRODUCT.GET_CARE_LABEL}/${devOrderId}`,

      payload,
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const editCareLabel = async (devOrderId, id, payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.GET_CARE_LABEL}/${devOrderId}/${id}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addProductIntoLibrary = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.GET_CARE_LABEL}`, {
      ...payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchLayoutData = async (devOrderId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.GET_CARE_LABEL_LAYOUT_DATA}/${devOrderId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const approveRejectData = async (devOrderId, payload) => {
  try {
    const urlParams = { devOrderId };
    return await apiClient.post(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.APPROVE_REJECT_PDF}`, { ...payload }, { params: urlParams });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const uploadPDFforCareLayout = async (devOrderId, payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.GET_CARE_LABEL_LAYOUT_DATA}/${devOrderId}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteCarePdf = async (devOrderId, id) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.GET_CARE_LABEL_LAYOUT_DATA}/${devOrderId}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deletePdfComments = async (devOrderId, payload) => {
  try {
    const urlParams = { devOrderId };
    return await apiClient.put(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.APPROVE_REJECT_PDF}`, { ...payload }, { params: urlParams });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveCareProductSequence = async (devOrderId, payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.SEQUENCE}/${devOrderId}`, { ...payload });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addCareUserInstruction = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.GET_PRODUCT_CARE_INSTRUCTION}/${data.devOrderId}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteCareInstruction = async (params) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.GET_PRODUCT_CARE_INSTRUCTION}/${params.devOrderId}`, params);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const rearrangeCareLabel = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.REARRANGE_CARE_LABEL}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getProductCareGroup = async (devOrderId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.GET_PRODUCT_CARE_GROUP}/${devOrderId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchCareProduct = async (devOrderId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.GET_PRODUCT_LIST}/${devOrderId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchCareLibraries = async (tabId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.GET_CARE_LIBRARIES}/${tabId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchProductCareData = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.GET_PRODUCT_CARE_DATA}/${data.devOrderId}/${data.tabId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const importCareLabel = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.IMPORT_CARE_LABEL}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const importCareGroup = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.IMPORT_CARE_GROUP}/${data.devOrderId}`, { tabId: data.tabId, groupId: data.groupId });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addToLibrary = async (devOrderId, data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.ADD_TO_LIBRARY}/${devOrderId}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const refreshTabs = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CARE_LABEL_PRODUCT.GET_PRODUCT_CARE_DATA_REFRESH}/${data}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
